export default {
  urlParameters: [],
  references: {},

  userSettings: {},
  columns: [],
  userVisibleColumns: {},
  currentAccountFeatureFlags: {},
  status: {},
};